import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const LabelRow = styled('span')<{ theme?: TTheme }>`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.colors.greys[800]};
`

export const BadgesWrapper = styled('span')`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`
